import { render, staticRenderFns } from "./AdminAppPaidShow.vue?vue&type=template&id=556c7b8a&scoped=true"
import script from "./AdminAppPaidShow.vue?vue&type=script&lang=js"
export * from "./AdminAppPaidShow.vue?vue&type=script&lang=js"
import style0 from "./AdminAppPaidShow.vue?vue&type=style&index=0&id=556c7b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c7b8a",
  null
  
)

export default component.exports